import React from 'react';
import { useHistory } from 'react-router-dom';
import { isModifiedClick } from '../logic';

type Props = {
  reviewId: string;
  name: string;
  // Whether the viewer may open this review. When false the name is plain text.
  accessible: boolean;
  buildDetailUrl: (reviewId: string) => string;
};

// A manager name that links to their review detail when the viewer has access,
// otherwise plain text. The link is a real <a href> (so the URL resolves and
// cmd/ctrl/middle-click open a new tab) but a plain primary click navigates
// in-app.
export const ReviewManagerLink: React.FC<Props> = ({
  reviewId,
  name,
  accessible,
  buildDetailUrl,
}) => {
  const history = useHistory();

  if (!accessible) {
    return <span>{name}</span>;
  }

  const url = buildDetailUrl(reviewId);
  return (
    <a
      href={url}
      onClick={(event) => {
        if (isModifiedClick(event)) {
          return;
        }
        event.preventDefault();
        history.push(url);
      }}>
      {name}
    </a>
  );
};
